import { render } from "./PathNotFound.vue?vue&type=template&id=324e529a&scoped=true"
const script = {}

import "./PathNotFound.vue?vue&type=style&index=0&id=324e529a&scoped=true&lang=css"

import exportComponent from "/home/nathan/Documentos/Creditall/Desenvolvimento/projetos/creditall/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-324e529a"]])

export default __exports__